import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Recipe for the "What's included" panel of the PDP details accordion.
 */
export default defineSlotRecipe({
    slots: ['container', 'items', 'list', 'item', 'text', 'imageWrapper', 'image'],
    base: {
        container: {
            flexDirection: {base: 'column', s: 'row'},
            width: 'full',
            height: '100%',
            gap: {base: 'spacing-32', s: 0}
        },
        items: {
            justifyContent: 'center',
            alignItems: 'center',
            flex: '1 1 0',
            minWidth: 0,
            width: 'auto'
        },
        list: {
            gap: 'spacing-24'
        },
        item: {
            flexDirection: 'row',
            gap: 3,
            alignItems: 'center'
        },
        text: {
            textStyle: 'heading.large'
        },
        imageWrapper: {
            justifyContent: 'center',
            alignItems: 'center',
            flex: '1 1 0',
            minWidth: 0,
            width: 'auto'
        },
        image: {
            width: {base: '100%', s: '34.5rem'},
            maxWidth: '100%'
        }
    }
})
